export enum ReversalTypeBillingValue {
  Void = 'Void',
  NSF = 'NSF',
  StopPay = 'Stop Pay'
}